import { getSerializer } from '@shared/serializers/serializer';

export const pictures = {
  type: 'picture',
  attributes: ['ownertType', 'ownerId', 'url']
};

export const PicturesSerializer = getSerializer(pictures);
